const stan = { type: 'radio', name: 'stan', options: ['Nowy', 'Uzywany'], tOptions: ['Nowe', 'Używane'] }
export default stan